import {Component, OnInit, OnDestroy} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {CustomValidators} from 'ng2-validation';
import {Subscription} from 'rxjs/Subscription';
import {EmissionService} from 'services/emission.service';
import {SpinnerService} from 'services/spinner.service';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';
import {EventsTravelService} from 'services/calculator-items/events-travel.service';
import {Constants} from 'config/constants';

@Component({
  selector: 'tpc-events-average',
  templateUrl: './events-average.component.html',
  styleUrls: ['./events-average.component.css']
})
export class EventsAverageComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    private isFormSubmitted = false;

    public form: FormGroup;

    constructor(protected emissionService: EmissionService,
                protected footerService: FooterNavbarService,
                protected fb: FormBuilder,
                protected spinner: SpinnerService,
                protected router: Router,
                protected eventsTravelService: EventsTravelService
    ) {
        this.nextSub = footerService.next$.subscribe(() => {
            this.isFormSubmitted = true;
            if (this.form.status === 'VALID') {
                this.next();
            }
        });
        this.createForm();
    }

    ngOnInit() {
    }

    private createForm() {
        this.form = this.fb.group({
            attendees: [1, this.getNumbersValidatorsArray()],
            miles: [1, this.getNumbersValidatorsArray()],
        });
    }

    private next() {
        let calculatorName = Constants.calculators.events;
        let categoryName = Constants.categories.events.travel;
        let params = {
            calculateBy: 'attendees',
            attendees: this.getFV('attendees'),
            miles: this.getFV('miles')
        };

        this.spinner.show();
        this.emissionService.getEmissionValue(params, calculatorName, categoryName).subscribe(
            response => {
                let input = response.body[0].input[0];
                this.eventsTravelService.addToList({
                    category: categoryName,
                    emission: {
                        emission: input.emmission,
                        emissionTrees: input.emissionTrees,
                        DollarAmt: input.DollarAmt,
                        DollarAmtMonthly: input.DollarAmtMonthly
                    }
                });

                this.router.navigate(['/events/travel/hotel']);
                this.spinner.hide();
            }
        );
    }

    private getNumbersValidatorsArray() {
        return [Validators.required, CustomValidators.min(1), CustomValidators.max(9999), CustomValidators.digits];
    }

    checkError(param) {
        return this.form.get(param).status === 'INVALID' && (this.isFormSubmitted || this.form.get(param).touched);
    }

    getFV(param) {
        return this.form.get(param).value;
    }

    ngOnDestroy() {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/events-calculator/events-travel/events-average/events-average.component.ts